<template>
    <div class="fixed-bottom" @click="clickEvent" >
        <button class="btn btn-info">
            {{$t('Buttons.SavedData')}}
            <!-- <i class="fas fa-check"></i> -->
        </button>
    </div>
</template>
<script>
export default {
    data() {
        return {            
        }
    },
    props : {
        clickEvent : Function
    },
    methods: {         
    },
    computed: {
    },
    mounted() {        
    }
}
</script>
<style lang="scss" scoped>
.fixed-bottom {
    left: auto;
    right: 80px;
    bottom: 10%;

    > .btn {
        width: 50px;
        height: 50px;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>